import { useListContextRequired, useShowContextRequired } from "ui-builder";
import { Project, useProjectDetailsService, useProjectsService } from "nekst-api";

export function useUpdateListHelper() {
  const listContext = useListContextRequired<Project>();

  const showContext = useShowContextRequired<Project>();

  const project = showContext.data;

  const projectDetailFieldsService = useProjectDetailsService();
  const projectsService = useProjectsService();

  const updateFieldsAndListView = async (fieldId: number, value: any) => {

    await projectDetailFieldsService.updateProjectDetails(project.id, {
      [fieldId]: value,
    });

    const newProjectData = await projectsService.getById(showContext.data.id, true);
    listContext._updateItems([newProjectData])
  }

  return {
    updateFieldsAndListView,
  }
}
